<div class="bottom-sheet-container">
  <button type="button" class="swipe-rect" (click)="toggleExpandCollapse()" >
    <span class="visually-hidden">Click here</span>
  </button>
  
  <mat-card appearance="outlined"  class="mat-card-custom">
    <mat-card-header>
      <mat-card-title>Symptoms Identified</mat-card-title>
    </mat-card-header>
    <mat-card-content class="symptoms-card-content card-content">Coming soon...</mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" class="mat-card-custom mt-2">
    <mat-card-header>
      <mat-card-title>Suggested Medications</mat-card-title>
    </mat-card-header>
    <mat-card-content class="medications-card-content card-content">Coming soon...</mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" class="mat-card-custom mt-2">
    <mat-card-header>
      <mat-card-title>Suggested Questions</mat-card-title>

      <mat-slide-toggle
          [(ngModel)]="toggleState"
          class="toggle-button"
          color="primary"
          hideIcon="true"
          (change) ="updateHeight()"
        >
      </mat-slide-toggle>
    </mat-card-header>
    <mat-card-content class="questions-card-content card-content">Coming soon...</mat-card-content>
  </mat-card>
</div>
